import cx from 'classnames';
import PropTypes from 'prop-types';

import { SearchField } from 'src/components/SearchField';

import { useStyles } from './useStyles';

export const MenuSearchField = ({ className, ...restProps }) => {
  const styles = useStyles();

  return (
    <SearchField
      className={cx(styles.root, className)}
      placeholder="Search by name or tag"
      {...restProps}
    />
  );
};

MenuSearchField.propTypes = {
  className: PropTypes.string,
};

MenuSearchField.defaultProps = {
  className: '',
};
